import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

/**
 * The connected −/count/+ pill from the mockup (a single bordered container with a filled "+"),
 * mode-aware: light = cream #FFF6D8 body / orange border / brand-red minus / orange-filled plus;
 * dark = charcoal body / gold border / gold minus / gold-filled plus. Shared by the product card
 * and the cart drawer so the two never drift.
 */
export default function QuantityStepper({
  value,
  onIncrement,
  onDecrement,
}: {
  value: number
  onIncrement: () => void
  onDecrement: () => void
}) {
  const { t } = useTranslation()
  const dark = useTheme().palette.mode === 'dark'
  const s = dark
    ? { bg: '#1A1310', border: '#E8B64A', bw: 1.5, radius: '8px', minus: '#EAA62F', plusBg: '#EAA62F', plusColor: '#1A1310' }
    : { bg: '#FFF6D8', border: '#F7A72B', bw: 2, radius: '999px', minus: 'primary.main', plusBg: '#F7A72B', plusColor: '#fff' }
  const cell = { width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        bgcolor: s.bg,
        border: `${s.bw}px solid ${s.border}`,
        borderRadius: s.radius,
        overflow: 'hidden',
      }}
    >
      <Box role="button" aria-label={t('common.decreaseQuantity')} onClick={onDecrement} sx={{ ...cell, color: s.minus }}>
        <RemoveIcon fontSize="small" />
      </Box>
      <Typography sx={{ minWidth: 22, textAlign: 'center', fontWeight: 800 }}>{value}</Typography>
      <Box role="button" aria-label={t('common.increaseQuantity')} onClick={onIncrement} sx={{ ...cell, bgcolor: s.plusBg, color: s.plusColor }}>
        <AddIcon fontSize="small" />
      </Box>
    </Box>
  )
}
